<script>
    export let audioMuted;
</script>

<button on:click>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 30 25.723">
                <path id="Path_14880" data-name="Path 14880" d="M272.98,292.636l-10.67,8.016a.622.622,0,0,0-.158.193H256V309.9h6.152a.716.716,0,0,0,.158.193l10.67,8.01a.64.64,0,0,0,1.025-.51V293.152A.642.642,0,0,0,272.98,292.636Z" transform="translate(-256 -292.508)" fill="#fff"/>
                {#if !audioMuted}
                <path id="Path_261" data-name="Path 261" d="M589.117,427.605a1.5,1.5,0,0,1-.756-2.795,4.333,4.333,0,0,0-.023-6.475,1.505,1.505,0,0,1-.492-2.051,1.488,1.488,0,0,1,2.027-.527,7.254,7.254,0,0,1,0,11.648,1.536,1.536,0,0,1-.756.2Z" transform="translate(-568.188 -408.346)" fill="#fff"/>
                <path id="Path_14881" data-name="Path 14881" d="M280.141,315.9a1.5,1.5,0,0,1-.762-2.795c.141-.082,3.615-2.25,3.615-7.734,0-5.566-3.58-7.711-3.615-7.734a1.5,1.5,0,0,1,1.512-2.59c.217.117,5.109,3.059,5.109,10.324s-4.893,10.207-5.1,10.324A1.483,1.483,0,0,1,280.141,315.9Z" transform="translate(-256 -292.508)" fill="#fff"/>
                {/if}
            </svg>

</button>

<style>
    button {
        padding-right: 20px;
    }

    button:hover svg {
        filter: invert(40%) sepia(70%) saturate(1696%) hue-rotate(336deg) brightness(103%) contrast(101%);
    }
</style>